import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveSingle } from "../../services/roomService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class RoomForm extends Form {
  state = {
    expiryDate: new Date(),
    data: {
      room_number: "",
      name: "",
      mobile: "",
      rent: "",
      emirates_id: "",
    },
    errors: {},
  };

  schema = {
    id: Joi.string(),
    room_number: Joi.string().required().label("Ledger type"),
    name: Joi.string().required().label("Name"),
    mobile: Joi.string().required().label("Mobile"),
    rent: Joi.number().required().label("Rent"),
    emirates_id: Joi.allow("").label("Emirates Id"),
  };

  handleChangeExpiry = (date) => {
    this.setState({
      expiryDate: date,
    });
  };

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });

      let formData = new FormData();
      formData.append("room_number", this.state.data.room_number);
      formData.append("name", this.state.data.name);
      formData.append("mobile", this.state.data.mobile);
      formData.append("rent", this.state.data.rent);
      formData.append("emirates_id", this.state.data.emirates_id);

      var event = new Date(this.state.expiryDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);
      formData.append("expiry_date", date);

      await saveSingle(formData);

      toast.success("Account has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/rooms-accounts");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.room_number)
          errors.room_number = ex.response.data.errors.room_number;

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.mobile)
          errors.mobile = ex.response.data.errors.mobile;

        if (ex.response.data.errors.rent)
          errors.rent = ex.response.data.errors.rent;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/room.png";
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Add room account</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/rooms-accounts")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Add room account</h3>
              <p>Provide the information below to add the account.</p>

              {this.renderInput("room_number", "Room Number", "text")}
              {this.renderInput("name", "Incharge Name", "text")}
              {this.renderInput("mobile", "Incharge Mobile", "text")}
              {this.renderInput("rent", "Rent", "text")}
              <label>Renewal Date</label>
              <DatePicker
                selected={this.state.expiryDate}
                onChange={this.handleChangeExpiry}
                className="input"
              />
              {this.renderInput("emirates_id", "Emirates Id", "text")}

              {this.renderButton("Save")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default RoomForm;
